module.exports = __webpack_public_path__ + "static/media/cvo-street-glide-white-pearl.d42d1d62.png";